import React from 'react';
import { Box, Typography, TextField, Button, CircularProgress, Chip } from '@mui/material';
import { Link as LinkIcon, CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { StepUrlEntryProps } from '../types';

/**
 * Step 1: URL entry and validation
 * Displays URL input field, validation button, and provider chip
 */
export const StepUrlEntry: React.FC<StepUrlEntryProps> = ({
  url,
  onChange,
  onValidate,
  isValidating,
  provider,
  error,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="body2" color="text.secondary" mb={2}>
        {t('shareFolder.enterLinkDescription')}
      </Typography>

      <TextField
        fullWidth
        label={t('shareFolder.linkLabel')}
        value={url}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('shareFolder.linkPlaceholder')}
        variant="outlined"
        disabled={isValidating}
        sx={{ mb: 2 }}
        InputProps={{
          startAdornment: <LinkIcon sx={{ mr: 1, color: 'text.secondary' }} />,
        }}
        error={Boolean(error)}
        helperText={error}
      />

      <Box display="flex" gap={2} alignItems="center">
        <Button
          variant="contained"
          onClick={onValidate}
          disabled={!url.trim() || isValidating}
          startIcon={
            isValidating ? (
              <CircularProgress size={20} />
            ) : (
              <CheckCircleIcon />
            )
          }
        >
          {isValidating ? t('shareFolder.validating') : t('shareFolder.validateLink')}
        </Button>

        {url && provider !== 'unknown' && (
          <Chip
            size="small"
            label={provider}
            color="primary"
            variant="outlined"
          />
        )}
      </Box>
    </>
  );
};
